// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".simple-timeline-info{position:relative;display:block;padding:0 0 0 5px;margin:0;list-style:none;max-height:274px}.simple-timeline-info>p{font-size:14px;font-weight:500;line-height:1.29;display:block;margin-bottom:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
